export default __webpack_public_path__ + "8c4f1b7be638973c5f782cf9f4bf4f2e.png";